import { Badge } from "@/components/ui";
import { badgeVariantFromConfig } from "@/lib/statusBadgeFromConfig";
import type { HandshakeSessionStatus, HandshakeMessageStatus } from "@/types";
import {
  SESSION_STATUS_CONFIG,
  MESSAGE_STATUS_CONFIG,
  handshakeSessionStatusLabel,
  handshakeMessageStatusLabel,
  channelLabel,
} from "./config";

const CHANNEL_BADGE_CONFIG = {
  WHATSAPP: { badgeVariant: "success" as const },
  SMS: { badgeVariant: "accent" as const },
  EMAIL: { badgeVariant: "default" as const },
};

interface SessionStatusBadgeProps {
  status: HandshakeSessionStatus;
  size?: "sm" | "md";
  className?: string;
}

export function SessionStatusBadge({
  status,
  size = "md",
  className,
}: SessionStatusBadgeProps) {
  const config = SESSION_STATUS_CONFIG[status];
  if (!config) return null;
  const Icon = config.icon;

  return (
    <Badge
      variant={badgeVariantFromConfig(status, SESSION_STATUS_CONFIG)}
      size={size === "sm" ? "sm" : "lg"}
      className={className}
    >
      <Icon />
      {handshakeSessionStatusLabel(status)}
    </Badge>
  );
}

interface MessageStatusBadgeProps {
  status: HandshakeMessageStatus;
  size?: "sm" | "md";
  className?: string;
}

export function MessageStatusBadge({
  status,
  size = "sm",
  className,
}: MessageStatusBadgeProps) {
  const config = MESSAGE_STATUS_CONFIG[status];
  if (!config) return null;
  const Icon = config.icon;

  return (
    <Badge
      variant={badgeVariantFromConfig(status, MESSAGE_STATUS_CONFIG)}
      size={size === "sm" ? "sm" : "md"}
      className={className}
    >
      <Icon />
      {handshakeMessageStatusLabel(status)}
    </Badge>
  );
}

interface ChannelBadgeProps {
  channel: string;
  size?: "sm" | "md";
  className?: string;
}

export function ChannelBadge({
  channel,
  size = "md",
  className,
}: ChannelBadgeProps) {
  return (
    <Badge
      variant={badgeVariantFromConfig(channel, CHANNEL_BADGE_CONFIG)}
      size={size}
      className={className}
    >
      {channelLabel(channel)}
    </Badge>
  );
}
